// Ensure jQuery is loaded
function initialize($) { // Pass jQuery as $
    const HTML_TEMPLATES = {
       
        styles:
            `
        <style id="warespaceGifLandingPage">
            .product-form__input input[type=radio]:checked+label.accent-color-text{
              border-color: black !important;
              border: 2px solid black !important;
            }
        </style>`
    }
    if ($("#warespaceGifLandingPage").length === 0) {
        $("head").append(HTML_TEMPLATES.styles);
    }

    const colorMap = {
      pink: 'linear-gradient(to right, #ffc0cb, #ff69b4)',       // light pink to hot pink
      red: 'linear-gradient(to right, #ff9999, #dc143c)',         // light red to crimson
      blue: 'linear-gradient(to right, #add8e6, #0070c0)',         // light blue to strong blue
      green: 'linear-gradient(to right, #90ee90, #008000)',       // light green to green
      yellow: 'linear-gradient(to right, #fffacd, #ffd700)',      // lemon chiffon to gold
      black: 'linear-gradient(to right, #6c757d, #000000)',       // gray to black
      orange: 'linear-gradient(to right, #ffd580, #ff8c00)',      // light orange to dark
      purple: 'linear-gradient(to right, #e6ccff, #800080)',      // lavender to purple
      brown: 'linear-gradient(to right, #d2b48c, #654321)',       // tan to dark brown
      grey: 'linear-gradient(to right, #d3d3d3, #696969)',       // light gray to dim gray
      leopard: 'linear-gradient(to right, #DEB887, #8B4513)',
      gray: 'linear-gradient(to right, #808080, #4D4D4D)',
      white: 'linear-gradient(to right,rgb(235, 232, 232), rgb(235, 232, 232))'
    };
    
      
    function isValidCssColor(color) {
        // treat “leopard” the same as “brown”
        if (color.trim().toLowerCase() === 'leopard') return true;
      
        const s = new Option().style;
        s.color = color;
        return s.color !== '';
      }
      
      
      $('label.accent-color-text').each(function () {
        const $label = $(this);
        const text = $label.clone().children().remove().end().text().trim().toLowerCase();
       
        const words = text.split(/[\/,\-\s]+/).filter(Boolean);

        const clean = w => w.trim().replace(/^[^\w#]+|[^\w#]+$/g, '');
        const norm  = w => w.toLowerCase() === 'grey' ? 'gray' : w.toLowerCase();
        
        const isColor = w => {
          const c = clean(w);
          return /^#(?:[0-9A-F]{3}|[0-9A-F]{6})$/i.test(c)
            || CSS.supports('color', c);
        };
        
        const banned = new Set(['silver','gold']);  // only these
        
        // debug:
        console.log(
          words.map(w => ({
            original: w,
            cleaned:  clean(w),
            norm:     norm(w),
            isColor:  isColor(w),
            banned:   banned.has(norm(w)),
          }))
        );
        
        // find last valid color
        const lastWord = [...words].reverse().find(w => {
            const c = clean(w);
            const n = norm(w);
          
            // exception: treat “leopard” as valid
            if (n === 'leopard') return true;
          
            return isColor(w) && !banned.has(n);
          });
          
        
        console.log('last valid color:', lastWord);
        

        
        
      
        if (colorMap[lastWord]) {
          if (words.length > 1) {
            $label.css({
              'background-image': colorMap[lastWord],
              'color': 'transparent',
              'width': '70px',
              'height': '36px',
              'font-size': '1px',
              'border': `1px solid ${lastWord}`
            });
          } else {
            
            $label.css({
              'background-color': lastWord === 'white'
              ? '#E3E6E7'
              : lastWord === 'blue'
              ? 'rgb(106 155 231)'
              : lastWord === 'purple'
              ? '#765166'
              : lastWord === 'brown'
              ? '#966A3A'
              : lastWord === 'leopard'
              ? '#DBCCCA'
              : lastWord,


              'color' : 'transparent',
              'width': '70px',
              'height': '36px',
              'font-size': '1px',
              'border': `1px solid ${lastWord === 'white'
                ? '#E3E6E7'
                : lastWord === 'blue'
                ? 'rgb(106 155 231)'
                : lastWord === 'purple'
                ? '#765166'
                : lastWord === 'brown'
                ? '#966A3A'
                : lastWord }`
            });
          }
        } else if (isValidCssColor(text)) {
          console.log("text color", text)
          $label.css({
            'background-color': text === 'white' ? '#E3E6E7' : text,
            'color': 'transparent',
            'width': '70px',
            'height': '36px',
            'font-size': '1px',
            'border': `1px solid ${lastWord}`
          });
        }
      });
      
      
      
      

}
//Initializing jquery and doing things as usual
if (typeof jQuery == 'undefined') {
    var script = document.createElement("script");
    script.src = "https://code.jquery.com/jquery-3.6.0.min.js"; // Load jQuery
    script.onload = function () {
        console.log("jQuery loaded ✅");
        jQuery.noConflict(); // Ensure no conflicts
        initialize(jQuery); // Pass jQuery explicitly
    };
    document.head.appendChild(script);
} else {
    initialize(jQuery); // If jQuery is already available, just run the function
}